<template>
  <button
    id="EmojiButton"
    :title="$t('sectionButtonEmoji.clickToChooseEmoji')"
    class="btn-text"
  >
    <i class="far fa-smile" />
  </button>
</template>

<script>
import EmojiButton from "@joeattardi/emoji-button";

export default {
  name: "ButtonEmoji",
  props: {
    evento: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  mounted() {
    const button = document.querySelector("#EmojiButton");
    const picker = new EmojiButton({ zIndex: 503, showSearch: false });
    let vm = this;

    picker.on("emoji", (emoji) => {
      //document.querySelector("input").value += emoji;
      vm.$emit(vm.evento, emoji);
    });

    button.addEventListener("click", () => {
      picker.togglePicker(button);
    });
  }
};
</script>

<style lang="scss"></style>
